import { useState } from "react";
import LibraryModal from '../LibraryModal';

export default function BlockImage({ block, setBlocks, updateBlock, className, isEditing }) {
    const [showLibraryModal, setShowLibraryModal] = useState(false);

    if(block.src == null){
        block.src = require('../../images/default-img.jpg');
    }

    const handleImageClick = () => {
        if (isEditing) {
            setShowLibraryModal(true);
        }
    };

    const handleImageSelect = (imageUrl, media) => {
        // Update the block's image source
        if (updateBlock) {
            updateBlock({ ...block, src: imageUrl });
        } else {
            // Fallback: directly update the block and DOM element
            block.src = imageUrl;
            const imageElement = document.getElementById(`image-${block.id}`);
            if (imageElement) {
                imageElement.src = imageUrl;
            }
        }
        setShowLibraryModal(false);
    };

    let imageWidth = 'w-full';
    let imageAlignment = 'justify-center';
    if(block.imageWidth ){
        imageWidth = 'w-'+block.imageWidth+'%';
    }
    if(block.imageAlignment){
        imageAlignment = 'justify-'+block.imageAlignment;
    }

    // Get proper flex alignment class
    let alignmentClass = 'justify-center'; // default center
    if(block.imageAlignment === 'left'){
        alignmentClass = 'justify-start';
    } else if(block.imageAlignment === 'right'){
        alignmentClass = 'justify-end';
    } else if(block.imageAlignment === 'center'){
        alignmentClass = 'justify-center';
    }

    
    return (
        <>
            <div className={`w-full rounded-lg ${className || ''}`}>
                <div className={`flex ${alignmentClass}  rounded-lg`}>
                    <img 
                        src={block.src} 
                        alt="Imagem" 
                        id={`image-${block.id}`}
                        onClick={handleImageClick}
                        className={`rounded-lg ${isEditing ? "cursor-pointer hover:opacity-70 transition-opacity" : ""}`}
                        title={isEditing ? "Clique para alterar a imagem" : ""}
                        style={{
                            width: `${block.imageWidth || 100}%`, 
                            height: 'auto',
                   
                        }}
                    />
                </div>
            </div>
        </>
    );
}